module.exports = __webpack_public_path__ + "img/twitter-icon.57286f4a.png";